import { css } from "@emotion/react";
import { useDisplayedPhoto } from "globalState/useDisplayedPhoto";
import { ChangeEvent, MouseEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextButton } from "component/button";
import { usePhotoBlobs } from "globalState";
import { PHOTO_DISPLAY_PATH, TIME_DIFFERENCE } from "config";
import { AiOutlineReload } from "react-icons/ai";
import { IconContext } from "react-icons";
import { SearchBar, MediaGrid } from "component";
import { RandomPhoto } from "./component/RandomPhoto";
import { MaintenanceBanner } from "./component/MaintenanceBanner";

type Props = {};

export const PhotoList = (props: Props) => {
  const [, setDisplayedPhoto] = useDisplayedPhoto();
  const [isAdditionalLoading, setIsAdditionalLoading] = useState<Boolean>(false);
  const [photos, setPhotos, addPhotos] = usePhotoBlobs();
  const navigate = useNavigate();
  let dateMillis = new Date().getTime();

  const onDateChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const dateStr = evt.target.value + " 00:00" + TIME_DIFFERENCE;
    dateMillis = new Date(dateStr).getTime();
  };

  const onSearchButtonClick = () => {
    setPhotos(dateMillis);
  };

  const onPhotoClick = (event: MouseEvent<HTMLImageElement>, index: number) => {
    setDisplayedPhoto(photos[index]);
    navigate(PHOTO_DISPLAY_PATH, { state: { isSwipe: true, photos: photos } });
  };

  const onVideoClick = (event: MouseEvent<HTMLDivElement>, index: number) => {
    setDisplayedPhoto(photos[index]);
    navigate(PHOTO_DISPLAY_PATH, { state: { isSwipe: true, photos: photos } });
  };

  const additionalLoad = async () => {
    setIsAdditionalLoading(true);
    try {
      await addPhotos();
    } catch (e) {
    } finally {
      setIsAdditionalLoading(false);
    }
  };

  const displayedElement = isAdditionalLoading ? (
    <div css={rotateCss}>
      <IconContext.Provider value={{ size: "1.5rem", color: "#000" }}>
        <AiOutlineReload />
      </IconContext.Provider>
    </div>
  ) : (
    <TextButton onClick={additionalLoad}>追加読み込み</TextButton>
  );

  return (
    <>
      <MaintenanceBanner />
      <SearchBar onInputChange={onDateChange} onSearchButtonClick={onSearchButtonClick} />
      <RandomPhoto />
      <MediaGrid photos={photos} onPhotoClick={onPhotoClick} onVideoClick={onVideoClick} />
      <section css={loadCss}>
        {displayedElement}
      </section>
    </>
  );
};

const loadCss = css`
  text-align: center;
  margin: 10px;
  color: gray;
`;

const rotateCss = css`
  display: inline-block;
  animation: rotate 1s linear infinite;

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;